import { Link, Tooltip } from '@mui/material';
import React from 'react';

type ActionLinkProps = {
  subdomain?: string;
  id: string;
};

export const GetCustomerEditActionLink = (props: ActionLinkProps) => {
  return (
    <Tooltip title="Edit">
      <Link href={`customer/${props.id}/edit`}>{props.subdomain}</Link>
    </Tooltip>
  );
};
